import type { ErrorObject } from 'serialize-error';

export class ApiDataError extends Error {
  constructor(message?: string) {
    super(message || 'Server returned bad data');
    this.name = 'ApiDataError';
  }
}

export class UnsupportedConnectorError extends Error {
  constructor(message?: string) {
    super(message || 'Unsupported connector');
    this.name = 'UnsupportedConnectorError';
  }
}

export class UnsupportedChainError extends Error {
  constructor(message?: string) {
    super(message || 'Unsupported chain');
    this.name = 'UnsupportedChainError';
  }
}

export class FailedMediaUploadError extends Error {
  constructor(message?: string) {
    super(message || 'Failed to upload media');
    this.name = 'FailedMediaUploadError';
  }
}

export class VerifyTransactionError extends Error {
  readonly name = 'VerifyTransactionError';
  readonly txHash: string;
  readonly chainId: number;
  readonly originalError?: ErrorObject;

  constructor({
    message,
    txHash,
    originalError,
    chainId,
  }: {
    message: string;
    txHash: string;
    chainId: number;
    originalError?: ErrorObject;
  }) {
    super(message);
    this.txHash = txHash;
    this.chainId = chainId;
    this.originalError = originalError;
  }
}

export class FormValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FormValidationError';
  }
}
